// CSS resources
import 'primeicons/primeicons.css'
import '@/assets/supercluster.css'
import '@/assets/main.css'

import Aura from '@primevue/themes/aura'
import { createPinia } from 'pinia'
import { en } from 'primelocale/js/en.js'
import PrimeVue from 'primevue/config'
import ConfirmationService from 'primevue/confirmationservice'
import ConfirmPopup from 'primevue/confirmpopup'
import FocusTrap from 'primevue/focustrap'
import Ripple from 'primevue/ripple'
import Toast from 'primevue/toast'
import ToastService from 'primevue/toastservice'
import { createApp } from 'vue'
import TextClamp from 'vue3-text-clamp'

// Manual icon import of Leaflet icons, so they are included in build for prod
import L from 'leaflet'
import defaultMarkerIconRetinaUrl from "leaflet/dist/images/marker-icon-2x.png";
import defaultMarkerIconUrl from "leaflet/dist/images/marker-icon.png";
import defaultMarkerShadowUrl from "leaflet/dist/images/marker-shadow.png";

// This is the workaround of workaround for dev because leaflet have a bad concatenation
// if (import.meta.env.DEV) {
//   L.Icon.Default.imagePath = "";
// }
// ok in prod but in dev need imagePath = ""
L.Icon.Default.mergeOptions({
    iconUrl: defaultMarkerIconUrl.src,
    iconRetinaUrl: defaultMarkerIconRetinaUrl.src,
    shadowUrl: defaultMarkerShadowUrl.src,
});

import App from './App.vue'
import i18n from "./i18n"
import router from './router'

const pinia = createPinia()
const app = createApp(App)

// wrapped in DOMContentLoaded beacuse error with vit hmr
// TypeError: Cannot read properties of null (reading 'nextSibling')
// https://stackoverflow.com/q/78443502
// document.addEventListener('DOMContentLoaded', async () => {})
// Se soluciona poniendo un elemento padre que envuelva todo el componente App
// que contiene el RouterView. En este caso:
// App.vue:   <template><div> ... <RouterView>...  </div></template>
//
// Aún queda el error "There is already an app instance mounted on the host
// container." que puede estar relacionado con Pinia, pero es menos molesto (no
// obliga a recargar la página dejando la aplicación en un estado de error pero
// sí que hay que volver a pinchar una segunda vez en el enlace para que el
// router lo cargue).

app.use(router)
app.use(pinia)
app.use(i18n)
// TODO: select locale automatically from browser. Here it's forced to spanish
// locales from [primelocale](https://github.com/primefaces/primelocale)
app.use(PrimeVue, {
  locale: en,
  theme: {
    preset: Aura,
    options: {
      darkModeSelector: '.my-app-dark'
    }
  },
  ripple: true
})
app.use(ToastService)
app.use(ConfirmationService)
app.directive('focustrap', FocusTrap)
app.directive('ripple', Ripple)
app.use(TextClamp)
// To be able to access toast service from outside components
// (useToast() can't be used from outside components, you get
// "inject() can only be used inside setup() or functional components" error.
// export const toast = app.config.globalProperties.$toast
app.component('ConfirmPopup', ConfirmPopup)
app.component('Toast', Toast)

// Primevue components not imported and registerd here.
// Using unplugin-vue-components to resolve and import automatically.
// This reduces bundle size of 'index' bundle.

/** Filter to pretty print objects and json from templates */
app.config.globalProperties.$filters = {
  pretty: (val, indent = 2) => {
    if (typeof val !== 'object') {
      try {
        val = JSON.parse(val)
      } catch {
        console.warn('value is not JSON')
        return val
      }
    }
    return JSON.stringify(val, null, indent)
  }
}

app.mount('#app')
